// pkg165a — the pkg81c "looks interrupted" hint under queued/running reports is removed (it fired on every healthy multi-hour run and told the user to re-drop); replaced with a neutral in-progress line — real progress reporting lands in pkg163b — delivered 2026-08-23
// pkg165 — GENERATE PLEADING (D-165a/b): a ready Assets & Liabilities report offers "Generate Asset & Liability List"; Income & Expenses offers "Generate Income & Expense Worksheet" — inline panel (no modal) with caption (prefilled from the client's pkg124 caption), filing party, worksheet timing, signature block, opposing counsel for the certificate of service, a neutral DRAFT-banner toggle (off = filing-clean per pkg83a), and the D-81d attestation; costs its own credits (shown on the button); downloads the .docx — delivered 2026-08-23
// pkg164a — the Resume panel distinguishes a synthesis-only rerun (all files already read: "only the report step runs — minutes, not hours") from a mid-extraction pause — delivered 2026-08-23
// pkg163 — RESUME A PAUSED RUN (D-163b): GET /reports now carries `resume` when the newest paused run's drop is still on the server; a panel above Reports says how far it got ("930 of 961 files already read"), why it paused, and offers Resume — attestation re-confirmed (D-81d), no re-upload, no re-transcription of the files already read — delivered 2026-08-21
// pkg163a — a 507 STAGING_FULL from the server is a real answer (staging budget / disk), not a blip: stop the batched upload immediately instead of retrying 3× — delivered 2026-08-20
// pkg161 — BATCHED UPLOAD, ONE DROP (D-161a/d/e): the attorney drops a folder of any size ONCE; the browser slices it into ≤150MB / ≤100-file batches and sends them sequentially into one staged drop (start → files ×N → finalize), each batch retried 3× with backoff so a network blip never restarts from zero; progress panel shows batch N of M and MB sent; drops under one batch still use the legacy single-POST inspect untouched; the audio/video scan (pkg160) runs on the WHOLE selection before batch 1 goes up; abandoning the page mid-upload cancels the drop server-side; copy notes that a single .zip over 150MB can't batch — drop the folder instead — delivered 2026-08-20
// pkg160 — AUDIO/VIDEO HARD STOP (D-160a/c): the selection is scanned BEFORE any byte uploads — if it contains audio or video (by extension or browser MIME) the drop is cancelled with a message naming the files; drop-zone copy says so; Step 1 card's stale "Income & Expenses, Assets & Liabilities, or Timeline" line (pkg83b era, pre-pkg149 picker) replaced with "any report other than Deficiency" — delivered 2026-08-20
// pkg150 — picker refinements (Ryan's review of pkg149): the Custom inquiry box and the Deficiency Step-1 card now open DIRECTLY UNDER their rows (they rendered below the whole list, off-screen); Discovery Deficiency promoted to a standalone featured card right after Custom; 'Case Analysis' split — Criminal Defense (criminal_digest, LABEL renamed to Criminal Defense Analysis, key unchanged so history rows keep resolving) + Miscellaneous (timeline, plus unknown server kinds); timeline blurb reframed to substantive events (backend prompt overhauled in the same pkg) — delivered 2026-08-16
// pkg149 (D-149d) — picker regrouped: Custom Inquiry stands ALONE at the top ('Ask the documents anything'), the rest under functional headers (Financial / Records / Business & Contracts / Case Analysis) with one-line blurbs; NO case-type gating; kinds still come from the server, unknown kinds fall into Case Analysis; row credit display (pkg95) and the custom/deficiency reveals unchanged; history labels map gains the seven pkg149 kinds — delivered 2026-08-16
// pkg141 — D-141a legacy .doc accepted (all three file inputs + drop-zone copy; the backend reads it via word-extractor and renamed RTF/HTML exports are skipped/rejected honestly); D-141c Custom Inquiry: fifth report kind — checking it reveals an inquiry textarea (2,000-char cap with live counter; run blocked under 20 chars, mirroring the server's validation); run sends custom_prompt; history rows for custom reports show the inquiry text under the title; base 2 credits rides the existing pkg95 exact-row pricing untouched — delivered 2026-08-09
// pkg91a — MightyAnalyzer™ (Ryan’s reassignment: MightyDiscovery belongs to the tool that DRAFTS discovery; this tool analyzes the other side’s production): title rebranded with ™ and tail; supersedes the pkg91 title — delivered 2026-07-18
// pkg91 — MightyDiscovery rename (UI chrome ONLY, house-mark-first ITU strategy): page title rebranded; every functional description, attestation, ledger label, and served/filed document string untouched (pkg83a absolute) — delivered 2026-07-18
// pkg95 — quote-screen shortfall flow + PER-ROW EXACT PRICING (revenue-friction fix + fair-billing display, Ryan's catch): (a) each CHECKED report row now shows the exact credits THAT report will bill under the current selection — base + its live share of the document-volume component, remainder to the first chosen, mirroring creditShares byte-for-byte so the row, the Total, and the later report-history row always agree (the old rows showed base only: "2 credits" clicked, "5 credits" charged); UNCHECKED rows show the true marginal cost ("+2" — adding a report never changes the shared component); (b) the quote panel tracks a LIVE balance (seeded from inspect, refreshed via getBillingStatus) — when the quote exceeds it, an amber notice states the shortfall with "Buy N credits" (opens Firm Wallet ?need=N in a NEW TAB so the quote screen and its 60-min drop handle survive the Stripe roundtrip) and "Refresh balance" (unlocks Run in place once the webhook lands); Run is disabled while short (mirrors precheckAiCredits exactly: multi-credit runs ignore free actions per D-81j, exempt firms bypass); an AI_NO_CREDITS error from /run auto-refreshes the balance — delivered 2026-07-17
// pkg94 — deficiency v2 quote support (D-94e): the requests upload now returns request_count + deficiency_extra_credits (regex-detected server-side, zero API spend) — the Step-1 confirmations show "~N numbered requests detected", the Deficiency kind row and the credits summary include the per-request component, and the run-button total matches the server's authoritative /run quote exactly (same server computation both places); size-limit era closed: Step-1 copy now says deficiency reviews cover the full production at any size; the interrupted-run hint threshold is 60 min for deficiency rows (a big multi-pass review legitimately runs 15–25 min) — delivered 2026-07-17
// pkg83b — the served-requests upload is now a FIRST-CLASS, always-visible Step 1 card on the landing screen (Ryan's order: your file first, their package second) — no longer hidden behind the Deficiency checkbox; uploading it pre-checks Discovery Deficiency on the quote screen; the drop zone is framed as Step 2 for deficiency runs and stays the plain drop for the other three reports — delivered 2026-07-15
// pkg83 — Discovery Deficiency (D-83a–g): selecting the new kind reveals Step 1 — upload the firm's SERVED requests (one Word/PDF) — plus the optional deficiency-letter checkbox (D-83d, firm's choice); run sends requests_id + deficiency_letter; ready deficiency rows offer both "Download exhibit" and "Download letter (draft)" — delivered 2026-07-14
// pkg82 — D-82a photos accepted (.jpg/.png/.webp/.heic — each counts as one scanned page); D-82b quote shows the pages-based scanned/photo surcharge; D-82d the skipped-file wall collapses to a one-line summary + expander — delivered 2026-07-14
// pkg81d — sweep-failed rows no longer double "nothing was charged" (the restart message already says it) — delivered 2026-07-14
// pkg81c — background polls swallow transient network errors (restart mid-poll splatted "Failed to fetch"); queued/running reports older than 30 min get an interrupted-run hint — delivered 2026-07-14
// pkg81b — honest picker labels ("Choose files or a .zip"; note that the folder picker only shows folders) + the inspecting message sets multi-minute upload expectations — delivered 2026-07-14
// pkg81 — Discovery Analysis v1 (D-81a–j): drop the opposing party's production (a folder dragged from the desktop, loose files, or a zip) → transient inspect + itemized credit quote → report multi-select + REQUIRED verification attestation (D-81d) + optional bill-to-client → async run with polling → Word downloads; files are processed and discarded, never stored — delivered 2026-07-14

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { adminApi } from '../utils/adminApi';

const META = 'Arial, sans-serif';
const NAVY = '#1E2761';

// pkg149 (D-149d) — functional grouping for the report picker. Custom is
// rendered standalone above these. A kind the map doesn't know falls into
// Case Analysis (forward compatibility with a newer backend).
const KIND_GROUPS = [
  // pkg150 — Deficiency is a standalone featured tool (rendered above these,
  // after Custom); Criminal gets its own category; the remainder is
  // Miscellaneous (unknown server kinds land there too).
  { label: 'Financial',            kinds: ['income_expenses', 'assets_liabilities', 'transactions'] },
  { label: 'Records',              kinds: ['medical_records', 'employment_records', 'communications'] },
  { label: 'Business & Contracts', kinds: ['contract_terms', 'performance_payment'] },
  { label: 'Criminal Defense',     kinds: ['criminal_digest'] },
  { label: 'Miscellaneous',        kinds: ['timeline'] },
];
const KIND_BLURBS = {
  custom:              'Write what the report should find — it returns exactly that, cited and cross-referenced.',
  income_expenses:     'What they earn and spend, item by item.',
  assets_liabilities:  'Property, accounts, and debts, with values as shown.',
  transactions:        'Where money moved — transfers, large or unusual activity, cash, new accounts.',
  medical_records:     'Providers, treatment dates, diagnoses, procedures, amounts, and gaps in treatment.',
  employment_records:  'Positions, pay history, reviews, discipline, and employment events.',
  communications:      'Texts, emails, and messages digested chronologically — who, to whom, when, what.',
  contract_terms:      'The agreements themselves — parties, price, scope, termination, amendments and change orders in order.',
  performance_payment: 'Invoices vs. payments, deliveries, delay and default notices, punch lists, liens.',
  timeline:            'A chronology of substantive events — what happened and when, not a restatement of the financial records.', // pkg150
  criminal_digest:     'The prosecution\u2019s discovery, digested for the defense — statements, investigation chronology, evidence inventory.', // pkg150 — Criminal Defense Analysis
  deficiency:          'Their responses checked request-by-request against what you served.',
};

// pkg160 — MightyAnalyzer reads documents and photos only. Audio/video is
// refused BEFORE upload (a 1GB folder with one .mov in it stops in a second,
// not after twenty minutes). Extension list mirrors the server's MEDIA_EXTS;
// the browser MIME type is checked too for extension-less files.
const MEDIA_EXTS = new Set(['.mp4', '.mov', '.avi', '.mkv', '.m4v', '.wmv', '.webm', '.3gp', '.3g2', '.mpg', '.mpeg', '.flv', '.mts', '.m2ts',
  '.mp3', '.m4a', '.wav', '.aac', '.ogg', '.oga', '.flac', '.wma', '.amr', '.aiff', '.aif', '.opus']);
function isMediaFile(f) {
  const name = String(f.name || '');
  const dot = name.lastIndexOf('.');
  const ext = dot >= 0 ? name.slice(dot).toLowerCase() : '';
  if (MEDIA_EXTS.has(ext)) return true;
  const t = String(f.type || '');
  return t.startsWith('audio/') || t.startsWith('video/');
}
function mediaMessage(names) {
  const shown = names.slice(0, 10).join(', ') + (names.length > 10 ? `, and ${names.length - 10} more` : '');
  return `This upload contains ${names.length} audio/video file${names.length === 1 ? '' : 's'}: ${shown}. MightyAnalyzer\u2122 reads documents and photos only. Remove the audio and video files and drop the folder again.`;
}

// pkg161 — batch sizing. Under one batch → legacy single-POST inspect.
const BATCH_BYTES = 150 * 1024 * 1024;
const BATCH_FILES = 100;
const BATCH_RETRIES = 3;
function sliceBatches(files) {
  const batches = [];
  let cur = [], curBytes = 0;
  for (const f of files) {
    if (cur.length && (curBytes + f.size > BATCH_BYTES || cur.length >= BATCH_FILES)) { batches.push(cur); cur = []; curBytes = 0; }
    cur.push(f); curBytes += f.size; // a single file over BATCH_BYTES travels alone
  }
  if (cur.length) batches.push(cur);
  return batches;
}
function fmtMB(b) { return b >= 1024 * 1024 * 1024 ? `${(b / 1024 / 1024 / 1024).toFixed(2)}GB` : `${Math.round(b / 1024 / 1024)}MB`; }

const ATTEST_TEXT =
  'AI can make mistakes. This report is a tool to assist my review — not a replacement for legal work. ' +
  'I will independently verify the accuracy of all information in this report before relying on it.';

// Walk a dropped DataTransfer: folders traverse recursively (webkitGetAsEntry),
// plain files pass through. Resolves to File[] — dotfiles skipped.
async function filesFromDrop(dataTransfer) {
  const out = [];
  const entries = [];
  for (const item of Array.from(dataTransfer.items || [])) {
    const entry = item.webkitGetAsEntry && item.webkitGetAsEntry();
    if (entry) entries.push(entry);
    else if (item.kind === 'file') { const f = item.getAsFile(); if (f) out.push(f); }
  }
  async function walk(entry) {
    if (entry.isFile) {
      if (entry.name && entry.name.startsWith('.')) return;
      const f = await new Promise((res, rej) => entry.file(res, rej)).catch(() => null);
      if (f) out.push(f);
    } else if (entry.isDirectory) {
      const reader = entry.createReader();
      // readEntries returns batches of ≤100 — loop until empty.
      let batch;
      do {
        batch = await new Promise((res, rej) => reader.readEntries(res, rej)).catch(() => []);
        for (const e of batch) await walk(e);
      } while (batch.length);
    }
  }
  for (const e of entries) await walk(e);
  return out.length ? out : Array.from(dataTransfer.files || []);
}

function StatusChip({ status }) {
  const styles = {
    queued:  { background: '#e8f0fb', color: '#2f5496', label: 'Queued' },
    running: { background: '#fdf6e6', color: '#7c5200', label: 'Running' },
    ready:   { background: '#d4edda', color: '#155724', label: 'Ready' },
    failed:  { background: '#f8d7da', color: '#721c24', label: 'Failed' },
  };
  const s = styles[status] || styles.queued;
  return (
    <span style={{ fontSize: 11, padding: '2px 10px', borderRadius: 9, fontWeight: 600, whiteSpace: 'nowrap', background: s.background, color: s.color }}>
      {s.label}
    </span>
  );
}

export default function AdminClientDiscoveryAnalysisPage() {
  const { id } = useParams();

  const [phase, setPhase]       = useState('drop'); // drop | inspecting | quote | started
  const [drop, setDrop]         = useState(null);   // the inspect response
  const [selected, setSelected] = useState({});     // kind → bool
  const [attest, setAttest]     = useState(false);
  const [billClient, setBillClient] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [error, setError]       = useState('');
  const [notice, setNotice]     = useState('');
  const [reports, setReports]   = useState([]);
  const [resume, setResume]     = useState(null);     // pkg163 — {drop_id, files_read, files_total, kinds, reason}
  const [resumeAttest, setResumeAttest] = useState(false); // pkg163
  const [resuming, setResuming] = useState(false);    // pkg163
  const [pleadFor, setPleadFor] = useState(null);     // pkg165 — report id with the pleading panel open
  const [pleadForm, setPleadForm] = useState(null);   // pkg165 — form fields
  const [pleadBusy, setPleadBusy] = useState(false);  // pkg165
  const [pleadCredits, setPleadCredits] = useState(2);// pkg165
  const [downloading, setDownloading] = useState('');
  const [showSkipped, setShowSkipped] = useState(false); // pkg82 (D-82d)
  const [reqDoc, setReqDoc]           = useState(null);   // pkg83 — {requests_id, name, pages}
  const [reqUploading, setReqUploading] = useState(false); // pkg83
  const [wantLetter, setWantLetter]   = useState(false);  // pkg83 (D-83d)
  const [customPrompt, setCustomPrompt] = useState('');   // pkg141 — the Custom Inquiry text
  const [balance, setBalance] = useState(null);           // pkg95 — live credit balance (null = unknown/exempt)
  const [balBusy, setBalBusy] = useState(false);          // pkg95
  const reqInputRef = useRef(null);                       // pkg83 — landing-card input (pkg83b)
  const reqInputRefQuote = useRef(null);                  // pkg83b — quote-panel input (separate mount)
  const fileInputRef = useRef(null);
  const folderInputRef = useRef(null);
  const [progress, setProgress] = useState(null);          // pkg161 — {batch, batches, sent, total} while a batched upload is in flight
  const pendingDropRef = useRef(null);                     // pkg161 — drop_id of an unfinished batched upload (cancelled on unmount)

  // pkg161 — abandoning the page mid-upload frees the staged files now
  // instead of at the 60-minute sweep.
  useEffect(() => () => {
    if (pendingDropRef.current) { adminApi.discoAnalysisDropCancel(id, pendingDropRef.current); pendingDropRef.current = null; }
  }, [id]);

  const loadReports = useCallback((silent) => {
    adminApi.discoAnalysisReports(id)
      .then((r) => { setReports(r.reports || []); setResume(r.resume || null); }) // pkg163
      .catch((err) => {
        // pkg81c — background polls swallow transient network blips (a server
        // restart mid-poll was splatting "Failed to fetch" across the page);
        // user-initiated loads still surface the error.
        if (!silent) setError(err.message);
      });
  }, [id]);
  useEffect(() => { loadReports(); }, [loadReports]);

  // Poll while anything is in flight so Ready appears without a refresh.
  const inFlight = reports.some((r) => r.status === 'queued' || r.status === 'running');
  useEffect(() => {
    if (!inFlight) return undefined;
    const t = setInterval(() => loadReports(true), 4000);
    return () => clearInterval(t);
  }, [inFlight, loadReports]);

  // pkg161 — start → files (×N) → finalize, one drop. Each batch retries
  // BATCH_RETRIES times with backoff; a hard server rejection (4xx) stops
  // immediately — that's a real answer (media, over cap), not a blip.
  async function inspectBatched(list) {
    const batches = sliceBatches(list);
    const total = list.reduce((s, f) => s + f.size, 0);
    const started = await adminApi.discoAnalysisDropStart(id);
    const dropId = started.drop_id;
    pendingDropRef.current = dropId;
    let sent = 0;
    try {
      for (let i = 0; i < batches.length; i++) {
        setProgress({ batch: i + 1, batches: batches.length, sent, total });
        const fd = new FormData();
        batches[i].forEach((f) => fd.append('files', f, f.name));
        let attempt = 0;
        for (;;) {
          try { await adminApi.discoAnalysisDropAddFiles(id, dropId, fd); break; }
          catch (err) {
            if (err.status && (err.status < 500 || err.status === 507)) throw err; // server said no — don't retry (pkg163a: 507 = staging full)
            attempt += 1;
            if (attempt >= BATCH_RETRIES) throw new Error(`Batch ${i + 1} of ${batches.length} failed after ${BATCH_RETRIES} tries (${err.message}). Check your connection and drop the folder again.`);
            await new Promise((r) => setTimeout(r, 1500 * attempt));
          }
        }
        sent += batches[i].reduce((s, f) => s + f.size, 0);
        setProgress({ batch: i + 1, batches: batches.length, sent, total });
      }
      setProgress({ batch: batches.length, batches: batches.length, sent: total, total, finalizing: true });
      const r = await adminApi.discoAnalysisDropFinalize(id, dropId);
      pendingDropRef.current = null;
      return r;
    } catch (err) {
      // The server already removed the drop on a 4xx/5xx it issued; a network
      // failure leaves it staged — free it.
      if (!(err.status && (err.status < 500 || err.status === 507))) adminApi.discoAnalysisDropCancel(id, dropId);
      pendingDropRef.current = null;
      throw err;
    } finally {
      setProgress(null);
    }
  }

  async function inspect(files) {
    setError(''); setNotice('');
    const list = Array.from(files || []).filter((f) => f && f.size > 0);
    if (!list.length) { setError('Nothing readable was dropped. Try again.'); return; }
    // pkg160 — audio/video stops the drop before a single byte uploads.
    const media = list.filter(isMediaFile).map((f) => f.name);
    if (media.length) { setError(mediaMessage(media)); return; }
    setPhase('inspecting');
    try {
      const totalBytes = list.reduce((s, f) => s + f.size, 0);
      let r;
      if (totalBytes <= BATCH_BYTES && list.length <= BATCH_FILES) {
        const fd = new FormData();
        list.forEach((f) => fd.append('files', f, f.name));
        r = await adminApi.discoAnalysisInspect(id, fd);
      } else {
        r = await inspectBatched(list); // pkg161 — same response shape
      }
      setDrop(r);
      setBalance(r.credit_balance != null ? r.credit_balance : null); // pkg95 — seed the live balance
      const pre = {};
      // pkg83b — if the attorney already uploaded their served requests
      // (Step 1), a Deficiency run is clearly the intent: pre-check it.
      (r.report_kinds || []).forEach((k) => { pre[k.kind] = k.kind === 'deficiency' && !!reqDoc; });
      setSelected(pre);
      setAttest(false); setBillClient(false); setShowSkipped(false);
      setWantLetter(false); // pkg83 — reqDoc survives on purpose (60-min TTL; re-dropping the production shouldn't force a re-upload)
      setPhase('quote');
    } catch (err) {
      setError(err.message);
      setPhase('drop');
    }
  }

  function onDrop(e) {
    e.preventDefault(); setDragOver(false);
    filesFromDrop(e.dataTransfer).then(inspect);
  }

  const chosen = drop ? (drop.report_kinds || []).filter((k) => selected[k.kind]) : [];
  // pkg94 (D-94e) — the deficiency price includes a per-request component
  // computed server-side at the requests upload (regex, zero API spend). The
  // same server computation prices /run, so this display always matches the
  // authoritative quote.
  const defExtra = reqDoc && Number.isFinite(reqDoc.deficiency_extra_credits) ? reqDoc.deficiency_extra_credits : 0;
  const kindCredits = (k) => k.base_credits + (k.kind === 'deficiency' ? defExtra : 0);
  const baseTotal = chosen.reduce((s, k) => s + kindCredits(k), 0);
  const sharedTotal = drop && chosen.length ? (drop.shared.pages + drop.shared.ocr) : 0;
  const quoteTotal = baseTotal + sharedTotal;

  // pkg95 — per-row EXACT pricing. Mirrors the server's creditShares
  // byte-for-byte: each chosen report bills its base (+ deficiency scope) plus
  // an equal slice of the shared document-volume component, remainder to the
  // FIRST chosen. The displayed row number is the number the report-history
  // row will show after the run. An unchecked row's marginal cost is just its
  // base (+ scope) — adding a report never changes the shared component.
  function rowCredits(k) {
    if (!selected[k.kind]) return { marginal: kindCredits(k) };
    const per = chosen.length ? Math.floor(sharedTotal / chosen.length) : 0;
    const rem = chosen.length ? sharedTotal - per * chosen.length : 0;
    const isFirst = chosen.length && chosen[0].kind === k.kind;
    return { exact: kindCredits(k) + per + (isFirst ? rem : 0) };
  }

  // pkg95 — the shortfall gate mirrors precheckAiCredits exactly: exempt
  // firms bypass, and free actions never apply to multi-credit runs (D-81j),
  // so balance vs. quote is the whole rule. balance === null (unknown) never
  // blocks — the server precheck stays the authority.
  const short = drop && !drop.exempt && chosen.length > 0 && balance != null && quoteTotal > balance
    ? quoteTotal - balance : 0;

  // pkg95 — re-read the balance in place (after a wallet purchase in the
  // other tab). getBillingStatus is the same source the wallet reads.
  async function refreshBalance() {
    setBalBusy(true);
    try {
      const b = await adminApi.getBillingStatus();
      setBalance(b && b.ai && b.ai.creditBalance != null ? b.ai.creditBalance : null);
    } catch (_) { /* keep the last known balance; server precheck still guards */ }
    finally { setBalBusy(false); }
  }

  // pkg83 — Step 1 of a deficiency run: the firm's served requests.
  async function uploadRequests(file) {
    if (!file) return;
    setError(''); setReqUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file, file.name);
      const r = await adminApi.discoAnalysisRequestsUpload(id, fd);
      setReqDoc(r);
    } catch (err) {
      setError(err.message);
    } finally {
      setReqUploading(false);
      if (reqInputRef.current) reqInputRef.current.value = '';
    }
  }

  // pkg163 — continue a paused run from its server-side checkpoints.
  // pkg165 — open the pleading panel for a report, prefilled from the client caption.
  async function openPleading(rep) {
    if (pleadFor === rep.id) { setPleadFor(null); return; }
    setError('');
    try {
      const pre = await adminApi.discoAnalysisPleadingPrefill(id);
      const cap = pre.caption || {};
      setPleadCredits(pre.pleading_credits || 2);
      setPleadForm({
        court: cap.caption_court || '', plaintiff: cap.caption_plaintiff || '', defendant: cap.caption_defendant || '',
        docket_no: cap.caption_docket_no || '', division: cap.caption_division || '',
        filing_party: cap.client_party === 'plaintiff' ? 'Plaintiff' : 'Defendant',
        represents: '', husband_is: '', producing_party: cap.client_party === 'plaintiff' ? 'Defendant' : 'Plaintiff',
        worksheet_timing: 'Pre-Divorce',
        attorney_name: pre.attorney_name || '', bpr: '', firm_name: '', firm_address: '', firm_phone: '', firm_email: '',
        opposing_counsel: cap.opposing_counsel || '',
        draft_banner: true, attest: false,
      });
      setPleadFor(rep.id);
    } catch (err) { setError(err.message); }
  }

  async function generatePleadingDoc(rep) {
    if (!pleadForm || pleadForm.attest !== true) return;
    setPleadBusy(true); setError('');
    try {
      const blob = await adminApi.discoAnalysisPleading(rep.id, pleadForm);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `${rep.kind === 'assets_liabilities' ? 'asset-liability-list' : 'income-expense-worksheet'}${pleadForm.draft_banner ? '-DRAFT' : ''}.docx`;
      document.body.appendChild(a); a.click(); a.remove();
      setNotice('Pleading generated — review every value against the source documents before filing.');
      setPleadFor(null);
    } catch (err) { setError(err.message); }
    finally { setPleadBusy(false); }
  }

  const PLEAD_LABEL = { assets_liabilities: 'Generate Asset & Liability List', income_expenses: 'Generate Income & Expense Worksheet' }; // pkg165

  async function resumeRun() {
    if (!resume || !resumeAttest) return;
    setError(''); setResuming(true);
    try {
      await adminApi.discoAnalysisResume(id, { drop_id: resume.drop_id, attest: true });
      setResume(null); setResumeAttest(false);
      setNotice(`Resumed — ${resume.files_read} of ${resume.files_total} files were already read and are not being transcribed again.`);
      loadReports();
    } catch (err) {
      setError(err.message);
      loadReports();
    } finally {
      setResuming(false);
    }
  }

  async function run() {
    setError(''); setNotice('');
    if (!chosen.length) { setError('Pick at least one report type.'); return; }
    if (!attest) { setError('Check the verification confirmation to run the analysis.'); return; }
    const deficiencyChosen = chosen.some((k) => k.kind === 'deficiency'); // pkg83
    if (deficiencyChosen && !reqDoc) { setError('Upload the discovery requests you served (Step 1) to run a Deficiency analysis.'); return; }
    const customChosen = chosen.some((k) => k.kind === 'custom'); // pkg141
    if (customChosen && customPrompt.trim().length < 20) { setError('Write the Custom Inquiry — at least a full sentence describing what the report should find.'); return; }
    try {
      await adminApi.discoAnalysisRun(id, {
        drop_id: drop.drop_id,
        kinds: chosen.map((k) => k.kind),
        attest: true,
        bill_to_client: billClient,
        requests_id: deficiencyChosen && reqDoc ? reqDoc.requests_id : undefined,       // pkg83
        deficiency_letter: deficiencyChosen ? wantLetter : undefined,                   // pkg83
        custom_prompt: customChosen ? customPrompt.trim() : undefined,                  // pkg141
      });
      setNotice(`Analysis started — ${chosen.length} report${chosen.length === 1 ? '' : 's'} queued. You can leave this page; we'll email you when they're ready.`);
      setPhase('drop'); setDrop(null); setReqDoc(null); setWantLetter(false); setCustomPrompt(''); // pkg83/pkg141 — one-shot, like the drop
      loadReports();
    } catch (err) {
      if (err.code === 'REQUESTS_EXPIRED') { setReqDoc(null); } // pkg83 — 60-min TTL lapsed
      else if (err.code === 'AI_NO_CREDITS') { refreshBalance(); } // pkg95 — surface the shortfall flow
      else if (err.status === 410) { setPhase('drop'); setDrop(null); }
      setError(err.message);
    }
  }

  async function download(rep) {
    setDownloading(rep.id); setError('');
    try {
      const blob = await adminApi.discoAnalysisDocx(rep.id);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `discovery-analysis-${rep.kind}-${new Date(rep.created_at).toISOString().slice(0, 10)}.docx`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.message);
    } finally {
      setDownloading('');
    }
  }

  const kindLabel = (kind) => ({
    income_expenses: 'Income & Expenses',
    assets_liabilities: 'Assets & Liabilities',
    timeline: 'Timeline',
    custom: 'Custom Inquiry', // pkg141
    deficiency: 'Discovery Deficiency', // pkg83
    medical_records: 'Medical Records Summary',          // pkg149
    communications: 'Communications Log',                // pkg149
    transactions: 'Transactions & Transfers',            // pkg149
    employment_records: 'Employment Record Summary',     // pkg149
    criminal_digest: 'Criminal Defense Analysis',         // pkg150 — renamed (key unchanged so old rows keep resolving)
    contract_terms: 'Contract Terms & Key Provisions',   // pkg149
    performance_payment: 'Performance & Payment History',// pkg149
  }[kind] || kind);

  // pkg83 — the optional letter draft rides the same report row.
  async function downloadLetter(rep) {
    setDownloading(rep.id + ':letter'); setError('');
    try {
      const blob = await adminApi.discoAnalysisLetter(rep.id);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `deficiency-letter-DRAFT-${new Date(rep.created_at).toISOString().slice(0, 10)}.docx`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.message);
    } finally {
      setDownloading('');
    }
  }

  return (
    <div>
      <h1 className="page-title">MightyAnalyzer™ — production analysis</h1>
      <p className="page-subtitle">
        Analyze the other side's discovery production. Drop the folder, pick the reports, and get a
        Word document for each — every item cited to its source document. Files are processed and
        discarded; nothing is stored on LawMighty.{' '}
        <Link to={`/admin/clients/${id}`}>Back to the client</Link>
      </p>

      {error  && <div className="alert alert-error">{error}</div>}
      {notice && <div className="alert alert-success">{notice}</div>}

      {/* pkg83b — Step 1, first-class and always visible: the firm's served
          discovery. Only a Deficiency run needs it, and the copy says so. */}
      {(phase === 'drop' || phase === 'inspecting') && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div style={{ fontFamily: META, fontSize: 14, fontWeight: 600, marginBottom: 4 }}>
            Step 1 — your served discovery <span style={{ fontWeight: 400, color: '#888' }}>(Deficiency analysis only)</span>
          </div>
          <div style={{ fontFamily: META, fontSize: 12.5, color: '#666', marginBottom: 10, lineHeight: 1.5 }}>
            Checking their responses against what you served? Upload the interrogatories / requests for
            production you sent (one Word or PDF, as served), then drop their response package in Step 2.
            Every request is checked against the full production, whatever its size — a large review can
            take 15+ minutes and we email you when it's ready.
            Running any report other than Deficiency? Skip this — go straight to Step 2. {/* pkg160 — picker is no longer family-law only (pkg149/150) */}
          </div>
          {reqDoc ? (
            <div style={{ fontFamily: META, fontSize: 13 }}>
              ✓ <strong>{reqDoc.name}</strong> — about {reqDoc.pages} page{reqDoc.pages === 1 ? '' : 's'}
              {reqDoc.request_count > 0 && <>, ~{reqDoc.request_count} numbered request{reqDoc.request_count === 1 ? '' : 's'} detected</>}, ready for a Deficiency run
              <button type="button" onClick={() => reqInputRef.current && reqInputRef.current.click()}
                style={{ background: 'none', border: 'none', color: NAVY, cursor: 'pointer', fontSize: 12, marginLeft: 10, padding: 0, textDecoration: 'underline' }}>
                Replace
              </button>
            </div>
          ) : (
            <button type="button" disabled={reqUploading}
              onClick={() => reqInputRef.current && reqInputRef.current.click()}
              style={{ background: 'none', color: NAVY, border: `1px solid ${NAVY}`, borderRadius: 4, padding: '7px 16px', cursor: reqUploading ? 'wait' : 'pointer', fontSize: 13 }}>
              {reqUploading ? 'Reading…' : 'Upload your interrogatories / RFPs (Word or PDF)'}
            </button>
          )}
          <input ref={reqInputRef} type="file" accept=".pdf,.doc,.docx" style={{ display: 'none' }}
            onChange={(e) => uploadRequests(e.target.files && e.target.files[0])} />
        </div>
      )}

      {(phase === 'drop' || phase === 'inspecting') && (
        <div className="card" style={{ marginBottom: 16 }}>
          <div style={{ fontFamily: META, fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
            Step 2 — their response package
          </div>
          <div
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={onDrop}
            style={{
              border: `2px dashed ${dragOver ? NAVY : '#c9cfdd'}`,
              borderRadius: 6, padding: '34px 16px', textAlign: 'center',
              background: dragOver ? '#F0F2F8' : '#fafbfd', transition: 'all .15s',
            }}>
            {phase === 'inspecting' ? (
              <div style={{ fontFamily: META, fontSize: 14, color: '#555', margin: 0 }}>
                {progress ? (
                  <>
                    {/* pkg161 — batched upload progress */}
                    <p style={{ margin: '0 0 8px', fontWeight: 600, color: NAVY }}>
                      {progress.finalizing
                        ? 'Upload complete — reading the documents and building your quote…'
                        : <>Uploading batch {progress.batch} of {progress.batches} · {fmtMB(progress.sent)} of {fmtMB(progress.total)}</>}
                    </p>
                    <div style={{ height: 8, background: '#e3e7ef', borderRadius: 4, overflow: 'hidden', maxWidth: 420, margin: '0 auto 10px' }}>
                      <div style={{ height: '100%', width: `${progress.total ? Math.round((progress.sent / progress.total) * 100) : 0}%`, background: NAVY, transition: 'width .3s' }} />
                    </div>
                    <p style={{ margin: 0, fontSize: 12.5, color: '#888' }}>
                      A production this size can take a while on upload speed alone. Leave this tab open —
                      if a batch hiccups it retries on its own; nothing restarts from zero.
                    </p>
                  </>
                ) : (
                  <p style={{ margin: 0 }}>
                    Uploading and reading the documents — a large folder can take several minutes on
                    upload speed alone. Leave this tab open; your quote will appear here.
                  </p>
                )}
              </div>
            ) : (
              <>
                <p style={{ fontFamily: META, fontSize: 15, fontWeight: 600, margin: '0 0 4px' }}>
                  Drag the opposing party's responses and production here
                </p>
                <p style={{ fontFamily: META, fontSize: 12.5, color: '#888', margin: '0 0 14px' }}>
                  Their written responses and produced documents together, exactly as received — a folder,
                  individual files, or a .zip. PDF, Word (.docx or older .doc), scanned documents, and phone
                  photos (.jpg, .png, .heic) all work. Unsupported files are simply skipped.
                </p>
                <p style={{ fontFamily: META, fontSize: 12.5, color: '#8a1f1f', margin: '0 0 14px' }}>
                  {/* pkg160 (D-160c) */}
                  Audio and video files are not accepted — remove them before uploading. MightyAnalyzer™ reads
                  documents and photos only.
                </p>
                <button
                  type="button"
                  onClick={() => folderInputRef.current && folderInputRef.current.click()}
                  style={{ background: NAVY, color: '#fff', border: 'none', borderRadius: 4, padding: '8px 16px', cursor: 'pointer', fontSize: 13, marginRight: 8 }}>
                  Choose a folder
                </button>
                <button
                  type="button"
                  onClick={() => fileInputRef.current && fileInputRef.current.click()}
                  style={{ background: 'none', color: NAVY, border: `1px solid ${NAVY}`, borderRadius: 4, padding: '7px 16px', cursor: 'pointer', fontSize: 13 }}>
                  Choose files or a .zip
                </button>
                <p style={{ fontFamily: META, fontSize: 11, color: '#999', margin: '10px 0 0' }}>
                  "Choose a folder" opens your computer's folder picker (it only shows folders — that's
                  normal). A downloaded .zip goes through "Choose files or a .zip" or straight into the drop zone.
                  Large productions upload in pieces automatically — for anything over 150MB, drop the
                  folder itself rather than one big .zip. {/* pkg161 (D-161d) */}
                </p>
                <input ref={folderInputRef} type="file" webkitdirectory="" directory="" multiple
                  style={{ display: 'none' }} onChange={(e) => inspect(e.target.files)} />
                <input ref={fileInputRef} type="file" multiple accept=".pdf,.doc,.docx,.txt,.zip,.jpg,.jpeg,.png,.webp,.heic,.heif"
                  style={{ display: 'none' }} onChange={(e) => inspect(e.target.files)} />
              </>
            )}
          </div>
        </div>
      )}

      {phase === 'quote' && drop && (
        <div className="card" style={{ marginBottom: 16 }}>
          <p style={{ fontFamily: META, fontSize: 14, margin: '0 0 2px' }}>
            <strong>{drop.totals.documents}</strong> document{drop.totals.documents === 1 ? '' : 's'} ·
            about <strong>{drop.totals.pages}</strong> page{drop.totals.pages === 1 ? '' : 's'}
            {drop.totals.ocr_pages > 0 && <> · {drop.totals.ocr_pages} scanned/photo page{drop.totals.ocr_pages === 1 ? '' : 's'}</>}
            {drop.totals.image_count > 0 && <> ({drop.totals.image_count} photo{drop.totals.image_count === 1 ? '' : 's'})</>}
          </p>
          {/* pkg82 (D-82d) — the wall of skipped filenames collapses to a
              one-line summary; the full list is one click away and always
              appears in the report itself. */}
          {(drop.skipped || []).length > 0 && (
            <div style={{ fontFamily: META, fontSize: 12, color: '#888', margin: '0 0 10px' }}>
              {drop.skipped.length} file{drop.skipped.length === 1 ? '' : 's'} skipped (unsupported or unreadable) — listed in the report, never an error.{' '}
              <button type="button" onClick={() => setShowSkipped(!showSkipped)}
                style={{ background: 'none', border: 'none', color: NAVY, cursor: 'pointer', fontSize: 12, padding: 0, textDecoration: 'underline' }}>
                {showSkipped ? 'Hide list' : 'Show list'}
              </button>
              {showSkipped && (
                <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
                  {drop.skipped.map((s, si) => <li key={si}>{s.name} ({s.reason})</li>)}
                </ul>
              )}
            </div>
          )}

          {/* pkg149 (D-149d) — the picker is GROUPED by function, never gated by
              case type (a divorce attorney legitimately wants the medical
              summary; a business litigator wants income & expenses). Custom
              Inquiry stands ALONE at the top — Ryan's direction: it may become
              the most used. Kinds still come from the SERVER (drop.report_kinds);
              a server kind this map doesn't know lands in Case Analysis, so a
              newer backend never hides a report. Row rendering (incl. the pkg95
              exact/marginal credits) is unchanged, just shared. */}
          <div style={{ fontFamily: META, fontSize: 12, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5, margin: '12px 0 8px' }}>
            Reports to run
          </div>
          {(() => {
            const byKind = {};
            (drop.report_kinds || []).forEach((k) => { byKind[k.kind] = k; });
            const renderRow = (k) => (
              <label key={k.kind} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontFamily: META, fontSize: 14, padding: '6px 0', cursor: 'pointer' }}>
                <input type="checkbox" checked={!!selected[k.kind]} style={{ marginTop: 3 }}
                  onChange={(e) => setSelected({ ...selected, [k.kind]: e.target.checked })} />
                <span style={{ flex: 1 }}>
                  {k.label}
                  {KIND_BLURBS[k.kind] && <span style={{ display: 'block', fontSize: 11.5, color: '#999', lineHeight: 1.35 }}>{KIND_BLURBS[k.kind]}</span>}
                </span>
                {/* pkg95 — checked rows show the EXACT credits this report will
                    bill under the current selection (matches the history row
                    after the run); unchecked rows show the true marginal cost
                    of adding it. pkg94 deficiency scope folds in either way. */}
                <span style={{ fontSize: 12, color: '#888', whiteSpace: 'nowrap' }}>
                  {drop.exempt
                    ? 'included'
                    : selected[k.kind]
                      ? `${rowCredits(k).exact} credit${rowCredits(k).exact === 1 ? '' : 's'}`
                      : `+${rowCredits(k).marginal} credit${rowCredits(k).marginal === 1 ? '' : 's'}`}
                </span>
              </label>
            );
            const grouped = new Set(['custom', 'deficiency']); // pkg150 — both render standalone above the groups
            KIND_GROUPS.forEach((g) => g.kinds.forEach((kk) => grouped.add(kk)));
            const strays = (drop.report_kinds || []).map((k) => k.kind).filter((kk) => !grouped.has(kk));
            const groupHeader = (label) => (
              <div key={`h-${label}`} style={{ fontFamily: META, fontSize: 11.5, color: '#aaa', textTransform: 'uppercase', letterSpacing: 0.5, margin: '10px 0 2px' }}>{label}</div>
            );
            return (
              <>
                {byKind.custom && (
                  <div style={{ background: '#f4f6fa', border: '1px solid #dfe5ef', borderRadius: 5, padding: '4px 12px 6px', margin: '0 0 6px' }}>
                    {groupHeader('Ask the documents anything')}
                    {renderRow(byKind.custom)}
                    {/* pkg150 — the inquiry box opens HERE, directly under the
                        row you just checked (it previously rendered below the
                        whole list, off-screen — you had to scroll to find it). */}
          {/* pkg141 — the Custom Inquiry: checking the kind reveals the
              inquiry box. The text directs what the report finds; the same
              facts-only, cite-everything rules as every other report apply. */}
          {selected.custom && (
            <div style={{ fontFamily: META, fontSize: 13, background: '#f4f6fa', border: '1px solid #dfe5ef', borderRadius: 5, padding: '10px 12px', margin: '10px 0 0' }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>What should this report find?</div>
              <textarea
                value={customPrompt}
                onChange={(e) => setCustomPrompt(e.target.value.slice(0, 2000))}
                rows={3}
                placeholder={'e.g. Find all dating-site transactions and potential alcohol purchases. Report every date, time, and amount, and cross-reference them against other transactions in the production.'}
                style={{ width: '100%', boxSizing: 'border-box', fontFamily: META, fontSize: 13, padding: '8px 10px', border: '1px solid #c9cfdd', borderRadius: 4, resize: 'vertical', lineHeight: 1.45 }}
              />
              <div style={{ fontSize: 11.5, color: customPrompt.trim().length > 0 && customPrompt.trim().length < 20 ? '#7c5200' : '#888', marginTop: 4 }}>
                {customPrompt.trim().length > 0 && customPrompt.trim().length < 20
                  ? 'Write at least a full sentence (20 characters minimum).'
                  : 'Every finding is cited to its source document, cross-referenced, and reported as facts only — one inquiry can list several things to find.'}
                <span style={{ float: 'right' }}>{customPrompt.length}/2000</span>
              </div>
            </div>
          )}
                  </div>
                )}
                {byKind.deficiency && (
                  <div style={{ background: '#f4f6fa', border: '1px solid #dfe5ef', borderRadius: 5, padding: '4px 12px 6px', margin: '0 0 6px' }}>
                    {groupHeader('Featured — request-by-request compliance')}
                    {renderRow(byKind.deficiency)}
                    {/* pkg150 — Step 1 opens directly under the row, same fix. */}
          {/* pkg83 — Step 1 for a Deficiency run: the firm's served requests. */}
          {selected.deficiency && (
            <div style={{ fontFamily: META, fontSize: 13, background: '#f4f6fa', border: '1px solid #dfe5ef', borderRadius: 5, padding: '10px 12px', margin: '10px 0 0' }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>Step 1 — the discovery requests you served</div>
              {reqDoc ? (
                <div>
                  ✓ {reqDoc.name} — about {reqDoc.pages} page{reqDoc.pages === 1 ? '' : 's'}
                  {reqDoc.request_count > 0 && <>, ~{reqDoc.request_count} numbered request{reqDoc.request_count === 1 ? '' : 's'} detected</>}
                  <button type="button" onClick={() => reqInputRefQuote.current && reqInputRefQuote.current.click()}
                    style={{ background: 'none', border: 'none', color: NAVY, cursor: 'pointer', fontSize: 12, marginLeft: 10, padding: 0, textDecoration: 'underline' }}>
                    Replace
                  </button>
                </div>
              ) : (
                <div>
                  <button type="button" disabled={reqUploading}
                    onClick={() => reqInputRefQuote.current && reqInputRefQuote.current.click()}
                    style={{ background: 'none', color: NAVY, border: `1px solid ${NAVY}`, borderRadius: 4, padding: '6px 14px', cursor: reqUploading ? 'wait' : 'pointer', fontSize: 12.5 }}>
                    {reqUploading ? 'Reading…' : 'Upload your interrogatories / RFPs (Word or PDF)'}
                  </button>
                  <div style={{ fontSize: 11.5, color: '#888', marginTop: 5 }}>
                    One file, as served. It must contain readable text — upload the Word version or an OCR'd PDF, not a scan.
                    Step 2 is the drop above: their written responses and produced documents together, exactly as received.
                  </div>
                </div>
              )}
              <input ref={reqInputRefQuote} type="file" accept=".pdf,.doc,.docx" style={{ display: 'none' }}
                onChange={(e) => uploadRequests(e.target.files && e.target.files[0])} />
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, margin: '10px 0 0', cursor: 'pointer' }}>
                <input type="checkbox" checked={wantLetter} onChange={(e) => setWantLetter(e.target.checked)} />
                <span>Also draft a deficiency letter to opposing counsel (a Word draft you edit and send on your own letterhead — no price difference)</span>
              </label>
            </div>
          )}
                  </div>
                )}
                {KIND_GROUPS.map((g) => {
                  const present = g.kinds.map((kk) => byKind[kk]).filter(Boolean)
                    .concat(g.label === 'Miscellaneous' ? strays.map((kk) => byKind[kk]) : []); // pkg150
                  if (!present.length) return null;
                  return (
                    <div key={g.label}>
                      {groupHeader(g.label)}
                      {present.map(renderRow)}
                    </div>
                  );
                })}
              </>
            );
          })()}

          {!drop.exempt && chosen.length > 0 && (
            <div style={{ fontFamily: META, fontSize: 13, color: '#555', borderTop: '1px solid #e4e9f0', marginTop: 8, paddingTop: 8 }}>
              {/* pkg95 — the rows above ARE the itemization now (exact,
                  share-inclusive); this line explains the shared component
                  and totals it. */}
              {sharedTotal > 0 && (
                <>Prices above include this drop's document-volume charge ({drop.shared.pages > 0 && <>{drop.shared.pages} credit{drop.shared.pages === 1 ? '' : 's'} for size</>}{drop.shared.pages > 0 && drop.shared.ocr > 0 && <> + </>}{drop.shared.ocr > 0 && <>{drop.shared.ocr} for scanned &amp; photo pages</>}, shared across the reports you pick). </>
              )}
              {selected.deficiency && reqDoc && defExtra > 0 && ( // pkg94
                <>Deficiency scope: ~{reqDoc.request_count} requests (+{defExtra} in its price). </>
              )}
              <span style={{ fontWeight: 700, color: '#111' }}>Total: {quoteTotal} credit{quoteTotal === 1 ? '' : 's'}</span>
              {balance != null && <span style={{ color: '#888' }}> (balance: {balance})</span>}
            </div>
          )}
          {/* pkg95 — the shortfall flow: buy in a NEW TAB so this quote screen
              (and its 60-minute drop handle) survives the Stripe roundtrip,
              then refresh in place. */}
          {short > 0 && (
            <div style={{ fontFamily: META, fontSize: 13, color: '#7c5200', background: '#fdf6e6', border: '1px solid #7c520033', borderRadius: 5, padding: '10px 12px', marginTop: 10 }}>
              <div style={{ marginBottom: 8 }}>
                This run needs <strong>{quoteTotal} credits</strong> and your firm has <strong>{balance}</strong> —
                {' '}{short} more credit{short === 1 ? '' : 's'} needed. Buying opens your Firm Wallet in a new tab;
                this screen (and your uploaded drop) stays right here.
              </div>
              <button type="button"
                onClick={() => window.open(`/admin/dashboard/firm-wallet?need=${short}`, '_blank', 'noopener')}
                style={{ background: NAVY, color: '#fff', border: 'none', borderRadius: 4, padding: '7px 14px', cursor: 'pointer', fontSize: 13, marginRight: 8 }}>
                Buy {short}+ credits
              </button>
              <button type="button" disabled={balBusy} onClick={refreshBalance}
                style={{ background: 'none', color: NAVY, border: `1px solid ${NAVY}`, borderRadius: 4, padding: '6px 14px', cursor: balBusy ? 'wait' : 'pointer', fontSize: 13 }}>
                {balBusy ? 'Checking…' : 'Refresh balance'}
              </button>
            </div>
          )}
          {drop.exempt && chosen.length > 0 && (
            <div style={{ fontFamily: META, fontSize: 13, color: '#555', borderTop: '1px solid #e4e9f0', marginTop: 8, paddingTop: 8 }}>
              Complimentary plan — no credits needed.
            </div>
          )}

          <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontFamily: META, fontSize: 12.5, color: '#7c5200', background: '#fdf6e6', border: '1px solid #7c520033', borderRadius: 5, padding: '10px 12px', margin: '14px 0 0', cursor: 'pointer', lineHeight: 1.5 }}>
            <input type="checkbox" checked={attest} onChange={(e) => setAttest(e.target.checked)} style={{ marginTop: 2 }} />
            <span>{ATTEST_TEXT}</span>
          </label>

          <label style={{ display: 'flex', alignItems: 'center', gap: 10, fontFamily: META, fontSize: 13, margin: '10px 0 0', cursor: 'pointer' }}>
            <input type="checkbox" checked={billClient} onChange={(e) => setBillClient(e.target.checked)} />
            <span>Bill to this client as an expense — $1.00 per credit, one expense per report (editable later on the Billing tab)</span>
          </label>

          <div style={{ marginTop: 14 }}>
            {/* pkg141 — customShort mirrors the server's 20-char minimum */}
            <button
              type="button"
              onClick={run}
              disabled={!chosen.length || !attest || (selected.deficiency && !reqDoc) || (selected.custom && customPrompt.trim().length < 20) || short > 0}
              style={{
                background: (!chosen.length || !attest || (selected.deficiency && !reqDoc) || (selected.custom && customPrompt.trim().length < 20) || short > 0) ? '#c9cfdd' : NAVY,
                color: '#fff', border: 'none', borderRadius: 4, padding: '9px 20px',
                cursor: (!chosen.length || !attest || (selected.deficiency && !reqDoc) || (selected.custom && customPrompt.trim().length < 20) || short > 0) ? 'not-allowed' : 'pointer', fontSize: 14, marginRight: 10,
              }}>
              {!chosen.length
                ? 'Pick at least one report'
                : (selected.deficiency && !reqDoc)
                  ? 'Upload your served requests (Step 1) first'
                  : (selected.custom && customPrompt.trim().length < 20)
                    ? 'Write the Custom Inquiry first' // pkg141
                    : short > 0
                      ? `Need ${short} more credit${short === 1 ? '' : 's'}` // pkg95
                      : `Run ${chosen.length} report${chosen.length === 1 ? '' : 's'}${drop.exempt ? '' : ` — ${quoteTotal} credit${quoteTotal === 1 ? '' : 's'}`}`}
            </button>
            <button
              type="button"
              onClick={() => { setPhase('drop'); setDrop(null); setError(''); }}
              style={{ background: 'none', color: '#666', border: '1px solid #ccc', borderRadius: 4, padding: '8px 16px', cursor: 'pointer', fontSize: 13 }}>
              Start over
            </button>
          </div>
          <p style={{ fontFamily: META, fontSize: 11, color: '#999', margin: '10px 0 0' }}>
            Credits are only used when a report completes — a failed run costs nothing. This drop expires in {drop.expires_in_minutes} minutes if not run.
          </p>
        </div>
      )}

      {resume && (
        /* pkg163 (D-163b) — a paused run with its drop still on the server */
        <div className="card" style={{ borderLeft: `4px solid ${NAVY}`, marginBottom: 18 }}>
          <div style={{ fontFamily: META, fontSize: 14, fontWeight: 700, color: NAVY, marginBottom: 4 }}>
            {resume.files_read >= resume.files_total
              ? <>Rerun the failed report{(resume.kinds || []).length === 1 ? '' : 's'} — all {resume.files_total} files are already read</>
              : <>A run paused before finishing — {resume.files_read} of {resume.files_total} files were already read</>}
          </div>
          <p style={{ fontFamily: META, fontSize: 13, color: '#555', margin: '0 0 10px' }}>
            {resume.reason ? <>Reason: {resume.reason}. </> : null}
            {resume.files_read >= resume.files_total
              ? <>Nothing is uploaded or transcribed again — only the report step runs (minutes, not hours). </>
              : <>Resume continues from where it stopped — no re-upload, and the {resume.files_read} files already read are not transcribed again. </>}
            Nothing was charged for the failed run. Available until {new Date(resume.expires_at).toLocaleDateString()}.
          </p>
          <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontFamily: META, fontSize: 12.5, color: '#333', marginBottom: 10 }}>
            <input type="checkbox" checked={resumeAttest} onChange={(e) => setResumeAttest(e.target.checked)} style={{ marginTop: 3 }} />
            <span>{ATTEST_TEXT}</span>
          </label>
          <button
            type="button"
            onClick={resumeRun}
            disabled={!resumeAttest || resuming}
            style={{ background: resumeAttest && !resuming ? NAVY : '#aab', color: '#fff', border: 'none', borderRadius: 4, padding: '9px 18px', cursor: resumeAttest && !resuming ? 'pointer' : 'not-allowed', fontSize: 14, fontWeight: 600 }}>
            {resuming ? 'Resuming…' : `Resume — ${(resume.kinds || []).length} report${(resume.kinds || []).length === 1 ? '' : 's'}`}
          </button>
        </div>
      )}

      <div className="section-head">Reports</div>
      <div className="card">
        {reports.length === 0 ? (
          <p style={{ fontFamily: META, fontSize: 13, color: '#888', margin: 0 }}>
            No reports yet — drop a production above to run the first one.
          </p>
        ) : (
          reports.map((rep, i) => (
            <div key={rep.id} style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', borderTop: i ? '1px solid #eee' : 'none', padding: '10px 0' }}>
              <div style={{ flex: 1, minWidth: 220 }}>
                <div style={{ fontFamily: META, fontSize: 14 }}>{kindLabel(rep.kind)} — discovery production</div>
                {/* pkg141 — a custom report is meaningless without its inquiry */}
                {rep.kind === 'custom' && rep.custom_prompt && (
                  <div style={{ fontFamily: META, fontSize: 12, color: '#555', marginTop: 2, fontStyle: 'italic' }}>
                    "{rep.custom_prompt.length > 160 ? `${rep.custom_prompt.slice(0, 160)}…` : rep.custom_prompt}"
                  </div>
                )}
                <div style={{ fontFamily: META, fontSize: 11.5, color: '#888', marginTop: 2 }}>
                  {new Date(rep.created_at).toLocaleString()}
                  {rep.file_count != null && <> · {rep.file_count} documents · ~{rep.page_count} pages</>}
                  {rep.ocr_used && <> · OCR</>}
                  {rep.truncated && <> · some documents truncated for length</>}
                  {rep.status === 'ready' && rep.credits_charged > 0 && <> · {rep.credits_charged} credit{rep.credits_charged === 1 ? '' : 's'}</>}
                  {rep.attested_name && <> · verification confirmed by {rep.attested_name}</>}
                </div>
                {rep.status === 'failed' && rep.error && (
                  /* pkg81d — the restart-sweep message already says "nothing
                     was charged"; don't say it twice. */
                  <div style={{ fontFamily: META, fontSize: 12, color: '#721c24', marginTop: 3 }}>
                    {rep.error}{/nothing was charged/i.test(rep.error) ? '' : ' — nothing was charged.'}
                  </div>
                )}
                {/* pkg165a — the pkg81c "looks interrupted" hint REMOVED: its
                    30/60-minute thresholds predate real productions (a 3,000-page
                    run legitimately extracts for hours) and it told users mid-run
                    to re-drop a healthy job. A genuinely dead run is still marked
                    failed by the pkg81c boot sweep; honest live progress arrives
                    with pkg163b. Until then, a neutral in-progress line. */}
                {(rep.status === 'queued' || rep.status === 'running') && (
                  <div style={{ fontFamily: META, fontSize: 12, color: '#666', marginTop: 3 }}>
                    Analysis in progress — a large production can take several hours. Leave this page open or come back later; you'll be emailed when the reports are ready.
                  </div>
                )}
              </div>
              <StatusChip status={rep.status} />
              {rep.status === 'ready' && PLEAD_LABEL[rep.kind] && (
                /* pkg165 (D-165a) */
                <button
                  type="button"
                  onClick={() => openPleading(rep)}
                  style={{ background: 'none', color: NAVY, border: `1px solid ${NAVY}`, borderRadius: 4, padding: '7px 13px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                  {pleadFor === rep.id ? 'Close' : PLEAD_LABEL[rep.kind]}
                </button>
              )}
              {rep.status === 'ready' && (
                <button
                  type="button"
                  onClick={() => download(rep)}
                  disabled={downloading === rep.id}
                  style={{ background: 'none', border: `1px solid ${NAVY}`, color: NAVY, borderRadius: 4, padding: '5px 12px', cursor: 'pointer', fontSize: 12 }}>
                  {downloading === rep.id ? '…' : rep.kind === 'deficiency' ? 'Download exhibit' : 'Download Word doc'}
                </button>
              )}
              {/* pkg83 — the optional letter draft (D-83d) */}
              {rep.status === 'ready' && rep.has_letter && (
                <button
                  type="button"
                  onClick={() => downloadLetter(rep)}
                  disabled={downloading === rep.id + ':letter'}
                  style={{ background: 'none', border: `1px solid ${NAVY}`, color: NAVY, borderRadius: 4, padding: '5px 12px', cursor: 'pointer', fontSize: 12 }}>
                  {downloading === rep.id + ':letter' ? '…' : 'Download letter (draft)'}
                </button>
              )}
            
              {pleadFor === rep.id && pleadForm && (
                /* pkg165 (D-165b) — inline pleading panel */
                <div style={{ flexBasis: '100%', background: '#f7f8fb', border: '1px solid #dfe3ee', borderRadius: 6, padding: 14, marginTop: 8 }}>
                  <div style={{ fontFamily: META, fontSize: 13.5, fontWeight: 700, color: NAVY, marginBottom: 8 }}>{PLEAD_LABEL[rep.kind]}</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                    {[
                      ['court', 'Court (full line)', 'IN THE CIRCUIT COURT FOR HAMILTON COUNTY, TENNESSEE'],
                      ['plaintiff', 'Plaintiff (full name)', ''],
                      ['defendant', 'Defendant (full name)', ''],
                      ['docket_no', 'Docket No.', ''],
                      ['division', 'Division', ''],
                      ['attorney_name', 'Attorney name', ''],
                      ['bpr', 'BPR #', ''],
                      ['firm_name', 'Firm name', ''],
                      ['firm_phone', 'Firm phone', ''],
                      ['firm_email', 'Firm email', ''],
                      ['represents', 'Attorney for (client name)', ''],
                    ].map(([k, label, ph]) => (
                      <label key={k} style={{ fontFamily: META, fontSize: 12, color: '#555' }}>
                        {label}
                        <input value={pleadForm[k]} placeholder={ph} onChange={(e) => setPleadForm({ ...pleadForm, [k]: e.target.value })}
                          style={{ display: 'block', width: '100%', boxSizing: 'border-box', marginTop: 3, padding: '7px 9px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13 }} />
                      </label>
                    ))}
                    <label style={{ fontFamily: META, fontSize: 12, color: '#555' }}>
                      Filing party
                      <select value={pleadForm.filing_party} onChange={(e) => setPleadForm({ ...pleadForm, filing_party: e.target.value })}
                        style={{ display: 'block', width: '100%', marginTop: 3, padding: '7px 9px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13 }}>
                        <option>Plaintiff</option><option>Defendant</option>
                      </select>
                    </label>
                    {rep.kind === 'assets_liabilities' ? (
                      <label style={{ fontFamily: META, fontSize: 12, color: '#555' }}>
                        Which party is the Husband? (for the value columns)
                        <select value={pleadForm.husband_is} onChange={(e) => setPleadForm({ ...pleadForm, husband_is: e.target.value })}
                          style={{ display: 'block', width: '100%', marginTop: 3, padding: '7px 9px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13 }}>
                          <option value="">Not specified</option><option value="Plaintiff">Plaintiff</option><option value="Defendant">Defendant</option>
                        </select>
                      </label>
                    ) : (
                      <label style={{ fontFamily: META, fontSize: 12, color: '#555' }}>
                        Worksheet timing
                        <select value={pleadForm.worksheet_timing} onChange={(e) => setPleadForm({ ...pleadForm, worksheet_timing: e.target.value })}
                          style={{ display: 'block', width: '100%', marginTop: 3, padding: '7px 9px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13 }}>
                          <option>Pre-Divorce</option><option>Post-Divorce</option>
                        </select>
                      </label>
                    )}
                  </div>
                  <label style={{ fontFamily: META, fontSize: 12, color: '#555', display: 'block', marginTop: 10 }}>
                    Firm address (one line per row)
                    <textarea rows={2} value={pleadForm.firm_address} onChange={(e) => setPleadForm({ ...pleadForm, firm_address: e.target.value })}
                      style={{ display: 'block', width: '100%', boxSizing: 'border-box', marginTop: 3, padding: '7px 9px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13 }} />
                  </label>
                  <label style={{ fontFamily: META, fontSize: 12, color: '#555', display: 'block', marginTop: 10 }}>
                    Opposing counsel — certificate of service (name, address lines, phone, email)
                    <textarea rows={4} value={pleadForm.opposing_counsel} onChange={(e) => setPleadForm({ ...pleadForm, opposing_counsel: e.target.value })}
                      style={{ display: 'block', width: '100%', boxSizing: 'border-box', marginTop: 3, padding: '7px 9px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13 }} />
                  </label>
                  <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontFamily: META, fontSize: 12.5, color: '#333', marginTop: 10 }}>
                    <input type="checkbox" checked={pleadForm.draft_banner} onChange={(e) => setPleadForm({ ...pleadForm, draft_banner: e.target.checked })} />
                    <span>Include a DRAFT banner (internal working copy — turn OFF for the version you file or serve)</span>
                  </label>
                  <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontFamily: META, fontSize: 12.5, color: '#333', marginTop: 8 }}>
                    <input type="checkbox" checked={pleadForm.attest} onChange={(e) => setPleadForm({ ...pleadForm, attest: e.target.checked })} style={{ marginTop: 3 }} />
                    <span>{ATTEST_TEXT}</span>
                  </label>
                  <button
                    type="button"
                    onClick={() => generatePleadingDoc(rep)}
                    disabled={!pleadForm.attest || pleadBusy}
                    style={{ marginTop: 10, background: pleadForm.attest && !pleadBusy ? NAVY : '#aab', color: '#fff', border: 'none', borderRadius: 4, padding: '9px 18px', cursor: pleadForm.attest && !pleadBusy ? 'pointer' : 'not-allowed', fontSize: 14, fontWeight: 600 }}>
                    {pleadBusy ? 'Generating…' : `Generate — ${pleadCredits} credit${pleadCredits === 1 ? '' : 's'}`}
                  </button>
                  <p style={{ fontFamily: META, fontSize: 11, color: '#999', margin: '8px 0 0' }}>
                    Values come only from this report; anything unevidenced reads "Not documented" and is excluded from the totals. Review every figure against the source documents.
                  </p>
                </div>
              )}
</div>
          ))
        )}
      </div>
      <p style={{ fontFamily: META, fontSize: 11, color: '#999', marginTop: 10 }}>
        AI can make mistakes. Every report is a starting point for attorney review — verify each item
        against the source documents before relying on it.
      </p>
    </div>
  );
}
